import * as React from 'react'
import { Create, FormDataConsumer, SelectInput, SimpleForm, TextInput } from 'react-admin'

import { AccountScoped } from 'shared/react-admin'
import { HiddenField } from 'dash/shared'

export const AccountCreate = () => {
  return (
    <AccountScoped view="Account Create">
      {(accountId: string) => (
        <Create>
          <SimpleForm variant="outlined">
            <TextInput source="name" />
            {/* <FormDataConsumer>
              {({ formData, ...rest }) => {
                return <ConfigEditInputs {...rest} record={formData} />;
              }}
            </FormDataConsumer> */}
            {/* <HiddenField source="accountId" value={accountId} /> */}
          </SimpleForm>
        </Create>
      )}
    </AccountScoped>
  )
}
